import { Site } from '@envato/foundation-types'

import { getConfigBySite } from '../../../config/sites'
import { Consent } from '../consent'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../localStorageHelpers'

const itemKey = (site: Site) => {
  return `${site}-search-page-views`
}

export const shouldTrackSearchCount = (site: Site) => {
  return !!getConfigBySite(site, 'surveys.search')
}

export const searchesCount = (site: Site) =>
  getLocalStorageItem(itemKey(site), Consent.statistics, 0)

export const countSearchFor = (site: Site) => {
  const newCount = getLocalStorageItem(itemKey(site), Consent.statistics, 0) + 1
  setLocalStorageItem(itemKey(site), newCount, Consent.statistics)
}
